/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KioskRouteImport } from './routes/kiosk'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as KioskActivateRouteImport } from './routes/kiosk.activate'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppAccountRouteImport } from './routes/app/account'
import { Route as AppPropertyIdRouteImport } from './routes/app/$propertyId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminPropertiesRouteImport } from './routes/admin/properties'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AppPropertyIdIndexRouteImport } from './routes/app/$propertyId/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminPropertiesIndexRouteImport } from './routes/admin/properties/index'
import { Route as AppPropertyIdZonesRouteImport } from './routes/app/$propertyId/zones'
import { Route as AppPropertyIdSettingsRouteImport } from './routes/app/$propertyId/settings'
import { Route as AppPropertyIdMembersRouteImport } from './routes/app/$propertyId/members'
import { Route as AppPropertyIdMapRouteImport } from './routes/app/$propertyId/map'
import { Route as AppPropertyIdEquipmentRouteImport } from './routes/app/$propertyId/equipment'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users.$userId'
import { Route as AdminPropertiesPropertyIdRouteImport } from './routes/admin/properties.$propertyId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskRoute = KioskRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const KioskActivateRoute = KioskActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => KioskRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertyIdRoute = AppPropertyIdRouteImport.update({
  id: '/$propertyId',
  path: '/$propertyId',
  getParentRoute: () => AppRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPropertiesRoute = AdminPropertiesRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AppPropertyIdIndexRoute = AppPropertyIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminPropertiesIndexRoute = AdminPropertiesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPropertiesRoute,
} as any)
const AppPropertyIdZonesRoute = AppPropertyIdZonesRouteImport.update({
  id: '/zones',
  path: '/zones',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AppPropertyIdSettingsRoute = AppPropertyIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AppPropertyIdMembersRoute = AppPropertyIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AppPropertyIdMapRoute = AppPropertyIdMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AppPropertyIdEquipmentRoute = AppPropertyIdEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => AppPropertyIdRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AdminUsersRoute,
} as any)
const AdminPropertiesPropertyIdRoute =
  AdminPropertiesPropertyIdRouteImport.update({
    id: '/$propertyId',
    path: '/$propertyId',
    getParentRoute: () => AdminPropertiesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/kiosk': typeof KioskRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/properties': typeof AdminPropertiesRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/app/$propertyId': typeof AppPropertyIdRouteWithChildren
  '/app/account': typeof AppAccountRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/kiosk/activate': typeof KioskActivateRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/properties/$propertyId': typeof AdminPropertiesPropertyIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/app/$propertyId/equipment': typeof AppPropertyIdEquipmentRoute
  '/app/$propertyId/map': typeof AppPropertyIdMapRoute
  '/app/$propertyId/members': typeof AppPropertyIdMembersRoute
  '/app/$propertyId/settings': typeof AppPropertyIdSettingsRoute
  '/app/$propertyId/zones': typeof AppPropertyIdZonesRoute
  '/admin/properties/': typeof AdminPropertiesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/app/$propertyId/': typeof AppPropertyIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/kiosk': typeof KioskRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/login': typeof AdminLoginRoute
  '/app/account': typeof AppAccountRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/kiosk/activate': typeof KioskActivateRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/admin/properties/$propertyId': typeof AdminPropertiesPropertyIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/app/$propertyId/equipment': typeof AppPropertyIdEquipmentRoute
  '/app/$propertyId/map': typeof AppPropertyIdMapRoute
  '/app/$propertyId/members': typeof AppPropertyIdMembersRoute
  '/app/$propertyId/settings': typeof AppPropertyIdSettingsRoute
  '/app/$propertyId/zones': typeof AppPropertyIdZonesRoute
  '/admin/properties': typeof AdminPropertiesIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/app/$propertyId': typeof AppPropertyIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/kiosk': typeof KioskRouteWithChildren
  '/login': typeof LoginRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/properties': typeof AdminPropertiesRouteWithChildren
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/app/$propertyId': typeof AppPropertyIdRouteWithChildren
  '/app/account': typeof AppAccountRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/kiosk/activate': typeof KioskActivateRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/admin/properties/$propertyId': typeof AdminPropertiesPropertyIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/app/$propertyId/equipment': typeof AppPropertyIdEquipmentRoute
  '/app/$propertyId/map': typeof AppPropertyIdMapRoute
  '/app/$propertyId/members': typeof AppPropertyIdMembersRoute
  '/app/$propertyId/settings': typeof AppPropertyIdSettingsRoute
  '/app/$propertyId/zones': typeof AppPropertyIdZonesRoute
  '/admin/properties/': typeof AdminPropertiesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/app/$propertyId/': typeof AppPropertyIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/admin'
    | '/app'
    | '/kiosk'
    | '/login'
    | '/admin/login'
    | '/admin/properties'
    | '/admin/users'
    | '/app/$propertyId'
    | '/app/account'
    | '/app/dashboard'
    | '/kiosk/activate'
    | '/admin/'
    | '/app/'
    | '/admin/properties/$propertyId'
    | '/admin/users/$userId'
    | '/app/$propertyId/equipment'
    | '/app/$propertyId/map'
    | '/app/$propertyId/members'
    | '/app/$propertyId/settings'
    | '/app/$propertyId/zones'
    | '/admin/properties/'
    | '/admin/users/'
    | '/app/$propertyId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/kiosk'
    | '/login'
    | '/admin/login'
    | '/app/account'
    | '/app/dashboard'
    | '/kiosk/activate'
    | '/admin'
    | '/app'
    | '/admin/properties/$propertyId'
    | '/admin/users/$userId'
    | '/app/$propertyId/equipment'
    | '/app/$propertyId/map'
    | '/app/$propertyId/members'
    | '/app/$propertyId/settings'
    | '/app/$propertyId/zones'
    | '/admin/properties'
    | '/admin/users'
    | '/app/$propertyId'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/admin'
    | '/app'
    | '/kiosk'
    | '/login'
    | '/admin/login'
    | '/admin/properties'
    | '/admin/users'
    | '/app/$propertyId'
    | '/app/account'
    | '/app/dashboard'
    | '/kiosk/activate'
    | '/admin/'
    | '/app/'
    | '/admin/properties/$propertyId'
    | '/admin/users/$userId'
    | '/app/$propertyId/equipment'
    | '/app/$propertyId/map'
    | '/app/$propertyId/members'
    | '/app/$propertyId/settings'
    | '/app/$propertyId/zones'
    | '/admin/properties/'
    | '/admin/users/'
    | '/app/$propertyId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  KioskRoute: typeof KioskRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/kiosk/activate': {
      id: '/kiosk/activate'
      path: '/activate'
      fullPath: '/kiosk/activate'
      preLoaderRoute: typeof KioskActivateRouteImport
      parentRoute: typeof KioskRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/$propertyId': {
      id: '/app/$propertyId'
      path: '/$propertyId'
      fullPath: '/app/$propertyId'
      preLoaderRoute: typeof AppPropertyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/properties': {
      id: '/admin/properties'
      path: '/properties'
      fullPath: '/admin/properties'
      preLoaderRoute: typeof AdminPropertiesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/$propertyId/': {
      id: '/app/$propertyId/'
      path: '/'
      fullPath: '/app/$propertyId/'
      preLoaderRoute: typeof AppPropertyIdIndexRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/properties/': {
      id: '/admin/properties/'
      path: '/'
      fullPath: '/admin/properties/'
      preLoaderRoute: typeof AdminPropertiesIndexRouteImport
      parentRoute: typeof AdminPropertiesRoute
    }
    '/app/$propertyId/zones': {
      id: '/app/$propertyId/zones'
      path: '/zones'
      fullPath: '/app/$propertyId/zones'
      preLoaderRoute: typeof AppPropertyIdZonesRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/app/$propertyId/settings': {
      id: '/app/$propertyId/settings'
      path: '/settings'
      fullPath: '/app/$propertyId/settings'
      preLoaderRoute: typeof AppPropertyIdSettingsRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/app/$propertyId/members': {
      id: '/app/$propertyId/members'
      path: '/members'
      fullPath: '/app/$propertyId/members'
      preLoaderRoute: typeof AppPropertyIdMembersRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/app/$propertyId/map': {
      id: '/app/$propertyId/map'
      path: '/map'
      fullPath: '/app/$propertyId/map'
      preLoaderRoute: typeof AppPropertyIdMapRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/app/$propertyId/equipment': {
      id: '/app/$propertyId/equipment'
      path: '/equipment'
      fullPath: '/app/$propertyId/equipment'
      preLoaderRoute: typeof AppPropertyIdEquipmentRouteImport
      parentRoute: typeof AppPropertyIdRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/admin/properties/$propertyId': {
      id: '/admin/properties/$propertyId'
      path: '/$propertyId'
      fullPath: '/admin/properties/$propertyId'
      preLoaderRoute: typeof AdminPropertiesPropertyIdRouteImport
      parentRoute: typeof AdminPropertiesRoute
    }
  }
}

interface AdminPropertiesRouteChildren {
  AdminPropertiesPropertyIdRoute: typeof AdminPropertiesPropertyIdRoute
  AdminPropertiesIndexRoute: typeof AdminPropertiesIndexRoute
}

const AdminPropertiesRouteChildren: AdminPropertiesRouteChildren = {
  AdminPropertiesPropertyIdRoute: AdminPropertiesPropertyIdRoute,
  AdminPropertiesIndexRoute: AdminPropertiesIndexRoute,
}

const AdminPropertiesRouteWithChildren = AdminPropertiesRoute._addFileChildren(
  AdminPropertiesRouteChildren,
)

interface AdminUsersRouteChildren {
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminLoginRoute: typeof AdminLoginRoute
  AdminPropertiesRoute: typeof AdminPropertiesRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminLoginRoute: AdminLoginRoute,
  AdminPropertiesRoute: AdminPropertiesRouteWithChildren,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppPropertyIdRouteChildren {
  AppPropertyIdEquipmentRoute: typeof AppPropertyIdEquipmentRoute
  AppPropertyIdMapRoute: typeof AppPropertyIdMapRoute
  AppPropertyIdMembersRoute: typeof AppPropertyIdMembersRoute
  AppPropertyIdSettingsRoute: typeof AppPropertyIdSettingsRoute
  AppPropertyIdZonesRoute: typeof AppPropertyIdZonesRoute
  AppPropertyIdIndexRoute: typeof AppPropertyIdIndexRoute
}

const AppPropertyIdRouteChildren: AppPropertyIdRouteChildren = {
  AppPropertyIdEquipmentRoute: AppPropertyIdEquipmentRoute,
  AppPropertyIdMapRoute: AppPropertyIdMapRoute,
  AppPropertyIdMembersRoute: AppPropertyIdMembersRoute,
  AppPropertyIdSettingsRoute: AppPropertyIdSettingsRoute,
  AppPropertyIdZonesRoute: AppPropertyIdZonesRoute,
  AppPropertyIdIndexRoute: AppPropertyIdIndexRoute,
}

const AppPropertyIdRouteWithChildren = AppPropertyIdRoute._addFileChildren(
  AppPropertyIdRouteChildren,
)

interface AppRouteChildren {
  AppPropertyIdRoute: typeof AppPropertyIdRouteWithChildren
  AppAccountRoute: typeof AppAccountRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppPropertyIdRoute: AppPropertyIdRouteWithChildren,
  AppAccountRoute: AppAccountRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface KioskRouteChildren {
  KioskActivateRoute: typeof KioskActivateRoute
}

const KioskRouteChildren: KioskRouteChildren = {
  KioskActivateRoute: KioskActivateRoute,
}

const KioskRouteWithChildren = KioskRoute._addFileChildren(KioskRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  KioskRoute: KioskRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
